import * as TYPES from './mutationTypes'

export default {
  //列表
  [TYPES.GET_CROSS_CHAINRECORD](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      crosschainrecord_list: payload.result.items,
      crosschainrecord_paging: { limit, offset, total }
    })
  }
}
